import { render, staticRenderFns } from "./DetailGoods.vue?vue&type=template&id=7631bb6f&scoped=true"
import script from "./DetailGoods.vue?vue&type=script&lang=js"
export * from "./DetailGoods.vue?vue&type=script&lang=js"
import style0 from "./DetailGoods.vue?vue&type=style&index=0&id=7631bb6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631bb6f",
  null
  
)

export default component.exports